import React, { useState, useRef, useEffect } from "react";
import { Bot, Image, Mic, Send, X, Minimize2, Maximize2 } from "lucide-react";
import "../../styles/Common/AiChat.css";

const AiChat = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [hasStartedChat, setHasStartedChat] = useState(false);
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!inputMessage.trim()) return;

    if (!hasStartedChat) {
      setHasStartedChat(true);
    }

    setMessages((prev) => [...prev, { type: "user", content: inputMessage }]);

    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        {
          type: "ai",
          content:
            "I'm an AI assistant. I'll be able to help you once the API is integrated.",
        },
      ]);
    }, 1000);

    setInputMessage("");
  };

  return (
    <div className="ai-chat-container">
      {!isOpen ? (
        <button className="ai-chat-button btn" onClick={() => setIsOpen(true)}>
          <img src="/aistar.svg" alt="" height={20} width={20} />
          <span>Ask AI</span>
        </button>
      ) : (
        <div className={`ai-chat-window ${isMinimized ? "minimized" : ""}`}>
          <div className="ai-chat-header">
            <div className="d-flex align-items-center gap-2">
              <img src="/aistar.svg" alt="" height={20} width={20} />
              <span className="fw-mediun chatbot-header-title">
                {" "}
                VAR <span className="textprimary"> 80 </span>{" "}
                <span className="ai-assist"> AI Assist </span>
              </span>
            </div>
            <div className="ai-chat-controls">
              <button
                className="control-btn"
                onClick={() => setIsMinimized(!isMinimized)}
              >
                {isMinimized ? (
                  <Maximize2 size={16} />
                ) : (
                  <Minimize2 size={16} />
                )}
              </button>
              <button className="control-btn" onClick={() => setIsOpen(false)}>
                <X size={16} />
              </button>
            </div>
          </div>

          {!hasStartedChat ? (
            <div className="ai-chat-welcome">
              <div className="welcome-image">
                <img
                  src="/aibot.svg"
                  alt="AI Assistant"
                  className="welcome-bot-image"
                />
              </div>
              <h2 className="welcome-title">Hello</h2>
              <p className="welcome-subtitle">How may I help you?</p>
            </div>
          ) : (
            <div className="ai-chat-messages">
              {messages.map((message, index) => (
                <div
                  key={index}
                  className={`message ${
                    message.type === "user" ? "user-message" : "ai-message"
                  }`}
                >
                  {message.type === "ai" && (
                    <div className="ai-avatar">
                      <Bot size={20} />
                    </div>
                  )}
                  <div className="message-content">{message.content}</div>
                </div>
              ))}
              <div ref={messagesEndRef} />
            </div>
          )}

          <form onSubmit={handleSubmit} className="ai-chat-input">
            <div  className="form-custom d-flex justify-content-space-evenly">
            <input
              type="text"
              value={inputMessage}
              onChange={(e) => setInputMessage(e.target.value)}
              placeholder="Ask me anything..."
            className="form-control input-no-border"
            />
            <button type="button" className="input-btn">
              <Image size={25} />
            </button>
            <button type="button" className="input-btn">
              <Mic size={25} />
            </button>
            </div>
            <button type="submit" className="send-btn btn" >
              <img src="/chatbot-send.svg" alt="" height={30} width={30} />
            </button>
          </form>

          <div className="ai-chat-footer">
            This conversation is only visible to you
          </div>
        </div>
      )}
    </div>
  );
};

export default AiChat;
